import React from 'react';
import ReactDOM from 'react-dom/client';
import './fonts.css'; // Import fonts first
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Import i18n configuration
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
